import NavBar from './components/NavBar';
import HeroSection from './components/HeroSection';
import ChannelsSection from './components/ChannelsSection';
import HowItWorksSection from './components/HowItWorksSection';
import UseCasesSection from './components/UseCasesSection';
import VerificationSection from './components/VerificationSection';
import PricingSection from './components/PricingSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import LeadCaptureSection from './components/LeadCaptureSection';
import Footer from './components/Footer';

export default function App() {
  return (
    <div className="min-h-screen bg-ink-950 text-white">
      <NavBar />
      <HeroSection />
      <ChannelsSection />
      <HowItWorksSection />
      <UseCasesSection />
      <VerificationSection />
      <PricingSection />
      <FAQSection />
      <CTASection />
      <LeadCaptureSection />
      <Footer />
    </div>
  );
}
